import React from "react";
import { Link } from "react-router-dom";

const estates = [
  {
    id: "royal-dynasty",
    name: "Royal Dynasty Estate",
    location: "Apo-Wumba, FCT Abuja",
    price: "2‑3 Bedroom • ₦40M – ₦50M",
    image: "/assets/img/estates/Royal Dynasty Estate.png",
  },
  {
    id: "emperor-villa",
    name: "Emperor Villa Estate",
    location: "Kodo, FCT Abuja (behind Life Camp)",
    price: "3‑5 Bedroom • ₦45M – ₦140M",
    image: "/assets/img/estates/Emperor Villa Estate_2.png",
  },
];

const TopEstates = () => {
  return (
    <>
      <style>{`
        .top-estates-page {
          background: #f9f9f9;
          min-height: 80vh;
        }
        .page-header {
          text-align: center;
          padding: 3rem 1rem 1rem;
        }
        .page-header h1 {
          font-size: 2.5rem;
          font-weight: 700;
          color: #0a1a3d;
        }
        .page-header p {
          color: #666;
          font-size: 1.1rem;
          max-width: 600px;
          margin: 1rem auto 0;
        }
        .estates-grid {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          gap: 30px;
          padding: 2rem 1rem 4rem;
          max-width: 1000px;
          margin: 0 auto;
        }
        .estate-card {
          background: #fff;
          border-radius: 20px;
          overflow: hidden;
          box-shadow: 0 12px 30px rgba(0,0,0,0.06);
          transition: transform 0.3s ease, box-shadow 0.3s ease;
          flex: 1 1 350px;
          max-width: 450px;
        }
        .estate-card:hover {
          transform: translateY(-8px);
          box-shadow: 0 20px 50px rgba(0,0,0,0.12);
        }
        .estate-card img {
          width: 100%;
          height: 280px;
          object-fit: cover;
        }
        .card-body {
          padding: 25px;
          text-align: center;
        }
        .card-body h3 {
          font-size: 1.6rem;
          font-weight: 700;
          color: #0a1a3d;
          margin-bottom: 0.5rem;
        }
        .card-body .location {
          color: #666;
          font-size: 1rem;
          margin-bottom: 0.5rem;
        }
        .card-body .price {
          color: #e86b24;
          font-weight: 600;
          font-size: 1.1rem;
          margin-bottom: 1.5rem;
        }
        .btn-view {
          display: inline-block;
          background: #e86b24;
          color: #fff;
          padding: 12px 30px;
          border-radius: 50px;
          font-weight: 600;
          text-decoration: none;
          transition: background 0.3s, transform 0.2s;
        }
        .btn-view:hover {
          background: #d2551a;
          transform: translateY(-2px);
        }
      `}</style>

      <div className="top-estates-page">
        <div className="page-header">
          <h1>Available Estates</h1>
          <p>
            Explore our premier estates in Abuja, designed for luxury living and
            smart investment.
          </p>
        </div>

        <div className="estates-grid">
          {estates.map((estate) => (
            <div className="estate-card" key={estate.id}>
              <img src={estate.image} alt={estate.name} />
              <div className="card-body">
                <h3>{estate.name}</h3>
                <p className="location">{estate.location}</p>
                <p className="price">{estate.price}</p>
                <Link to={`/estates/${estate.id}`} className="btn-view">
                  View Details
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default TopEstates;
